/**
 * ResourceGrid — one small multiple per resource group, rendered only when the scope is a
 * single entity. Split from Overview on the CD-1 budget when the grid came back.
 */

import React from 'react'
import ResourceCard from './ResourceCard'
import type { SurfaceData } from '../../hooks/useLoadingSurface'

interface Hover {
  card: string
  index: number
}

/** One small multiple per resource group — AT AN ENTITY ONLY (19 Aug 2026, Mike).
 *
 *  At Group the wall was thirteen charts drawn from two estates that share no machines,
 *  which is a scroll rather than a comparison; the lanes above already say which groups
 *  never clear. Inside Kirkstall or Oracle it is six or seven charts of one estate, and
 *  that IS the comparison — so the charts come back the moment the scope is one entity.
 *  The card also carries the still-queued ghost the full-size chart leaves to its
 *  burn-down line, which is the one thing the lanes cannot show. */
export default function ResourceGrid({ data, levelled, onOpen }: {
  data: SurfaceData
  levelled: boolean
  onOpen: (id: string, week: number) => void
}): React.JSX.Element {
  const [hover, setHover] = React.useState<Hover | null>(null)
  return (
    <div className="grid grid-cols-1 gap-3.5 px-[22px] pb-[22px] pt-5 lg:grid-cols-2">
      {data.resources.map((r) => (
        <ResourceCard
          key={r.id}
          r={r}
          levelled={levelled}
          showEntity={false}
          hovered={hover?.card === r.id ? hover.index : null}
          onHover={(index) => setHover(index === null ? null : { card: r.id, index })}
          onOpen={(week) => onOpen(r.id, week)}
        />
      ))}
    </div>
  )
}
